// extracted by mini-css-extract-plugin
export default {"message-settings":"NotificationsSettings_message-settings__7jdxc","channel":"NotificationsSettings_channel__-Yldc","switcher":"NotificationsSettings_switcher__pMGMC"};